import { Action } from "../../../models/Action";
import { StandAloneActions, StandAloneState } from "../../../models/StandAloneData";

const initialState: StandAloneState = {
  importId: null,
  importDetailId: null,
  containerType: null,
  fileName: "",
  fileType: null,
  status: null,
  page: 0,
  serverPage: 0,
  serverPageChange: null,
  taxTableIndex: 0,
  taxTableIndexChange: null,
  importFilesData: null,
  applyFilterClick: false,
  filterData: {
    companyId: null,
    companyName: null,
    fileType: null,
    isProduction: null,
    status: null,
    containerType: null,
    submissionType: null
  }
};

function standAloneReducer(
  state: StandAloneState,
  action: Action<StandAloneActions>
): StandAloneState {
  switch (action.type) {
    case StandAloneActions.SET_SELECTED_FILE:
      return {
        ...state,
        importId: action.payload.importId,
        containerType: action.payload.containerType ?? null,
        fileName: action.payload.fileName,
        fileType: action.payload.fileType,
        status: action.payload.status
      };
    case StandAloneActions.SET_IMPORT_DETAIL:
      return {
        ...state,
        importDetailId: action.payload.importDetailId
      };
    case StandAloneActions.PAGING:
      return handlePaging(state, action);
    case StandAloneActions.SET_MAIN_PAGE:
      return setMainPage(state, action);
    case StandAloneActions.SET_TAX_PAGE:
      return setTaxPage(state, action);
    case StandAloneActions.SET_FILTER_DATA:
      return setFilterData(state, action);
    default:
      return state;
  }
}

function handlePaging(
  state: StandAloneState,
  action: Action<StandAloneActions>
): StandAloneState {
  const { pageIdx } = action.payload;
  return {
    ...state,
    serverPage: pageIdx
  }
};

function setMainPage(
  state: StandAloneState, 
  action: Action<StandAloneActions>
): StandAloneState {
  const { pageIdx, applyFilterClick } = action.payload;
  return {
    ...state,
    serverPageChange: !state.serverPageChange
  };
}

function setTaxPage(
  state: StandAloneState, 
  action: Action<StandAloneActions>
): StandAloneState {
  const { pageIdx } = action.payload;
  return {
    ...state,
    serverPage: pageIdx,
    taxTableIndexChange: !state.taxTableIndexChange
  };
}

function setFilterData(
  state: StandAloneState, 
  action: Action<StandAloneActions>
): StandAloneState {
  const { pageIdx, filterValues } = action.payload;
  return {
    ...state,
    serverPage: pageIdx,
    applyFilterClick: !state.applyFilterClick,
    filterData: {
      companyId: filterValues?.companyId ?? null,
      companyName: filterValues?.companyName ?? null,
      fileType: filterValues?.fileType ?? null,
      isProduction: filterValues?.isProduction ?? null,
      status: filterValues?.status ?? null,
      containerType: filterValues?.containerType ?? null,
      submissionType: filterValues?.submissionType ?? null
    }
  };
}

export { standAloneReducer, initialState };
